import React from "react"
import { Button, Result } from "antd"
import { useNavigate } from "react-router-dom"

const Unauthorized = () => {
  const navigate = useNavigate()

  return (
    <Result
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this page."
      extra={
        <div className="flex gap-3 justify-center">
          {/* <Button type="primary" onClick={() => navigate("/dashboard")}>
            Back to Dashboard
          </Button> */}
          <Button onClick={() => navigate("/login")}>
            Go to Login
          </Button>
        </div>
      }
    />
  )
}

export default Unauthorized
